// extracted by mini-css-extract-plugin
module.exports = {"item":"dd31006766--item--cM5VI","label":"dd31006766--label--h1kOF","selected-indicator":"dd31006766--selected-indicator--v5tTE"};